export enum AppTypeEnum {
binding = 'binding',
testing = 'testing',
stocking = 'stocking'
}